import { Check } from 'lucide-react';
import { ui, fmt } from './pricingData';
import { buildWhatsAppLink } from '@/components/services/servicesData';

const waMessage = (pack, lang, from) => {
  const tx = (o) => o?.[lang] || o?.en;
  const price = `${from ? (lang === 'es' ? 'Desde ' : 'From ') : ''}${fmt(pack.price)} USD`;
  const head = lang === 'es'
    ? `¡Hola, Jotunheims! Estoy interesado en el paquete "${tx(pack.name)}" (${price}).`
    : `Hi Jotunheims! I'm interested in the "${tx(pack.name)}" package (${price}).`;
  const list = pack.features.map((f) => `• ${tx(f)}`).join('\n');
  const tail = lang === 'es' ? 'Me gustaría recibir más información para comenzar.' : "I'd like more information to get started.";
  return `${head}\n\n${tx(pack.desc)}\n${list}\n\n${tail}`;
};

export default function PricingCard({ pack, lang, from }) {
  const tx = (o) => o?.[lang] || o?.en;
  return (
    <div className={`relative flex flex-col rounded-2xl border p-7 backdrop-blur-sm transition-all duration-500 hover:-translate-y-1 ${pack.popular ? 'border-primary/60 bg-primary/5 shadow-lg shadow-primary/10' : 'border-border/50 bg-card/50 hover:border-primary/30'}`}>
      {pack.popular && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold tracking-widest uppercase">
          {tx(ui.popular)}
        </span>
      )}
      <h3 className="font-inter font-bold text-lg text-foreground">{tx(pack.name)}</h3>
      {pack.tagline && <p className="text-xs text-primary font-medium tracking-wide mt-1">{tx(pack.tagline)}</p>}
      <div className="mt-5 mb-4">
        {from && <span className="block text-xs uppercase tracking-widest text-muted-foreground">{tx(ui.from)}</span>}
        <span className="font-inter font-black text-4xl text-foreground">{fmt(pack.price)}</span>
        <span className="text-sm text-muted-foreground ml-1">USD</span>
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed mb-5">{tx(pack.desc)}</p>
      <ul className="space-y-2.5 mb-7 flex-1">
        {pack.features.map((f) => (
          <li key={f.en} className="flex gap-2.5 text-sm text-foreground/90">
            <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" />
            <span>{tx(f)}</span>
          </li>
        ))}
      </ul>
      <a href={buildWhatsAppLink(waMessage(pack, lang, from))} target="_blank" rel="noopener noreferrer" className={`text-center py-3 rounded-lg text-sm font-semibold tracking-wider uppercase transition-all ${pack.popular ? 'bg-primary text-primary-foreground hover:bg-primary/90' : 'border border-border text-foreground hover:border-primary/50 hover:text-primary'}`}>
        {tx(ui.cta)}
      </a>
    </div>
  );
}